PJQ.collections.invoicing = {};

PJQ.models.invoicing = {};

PJQ.views.invoicing = {};

PJQ.modules.invoicing = {
    routes: [
        {
            route: 'projects/:projectId/invoicing',
            name: 'invoicing',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing");
            }
        },
        {
            route: 'projects/:projectId/invoicing/payable',
            name: 'payableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    view: 'payable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/payable/:invoiceId',
            name: 'commitment',
            callback: function (projectId, invoiceId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    invoiceId: parseInt(invoiceId),
                    view: 'payable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/payable/payments/:paymentId',
            name: 'commitment',
            callback: function (projectId, paymentId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    paymentId: parseInt(paymentId),
                    view: 'payable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/receivable',
            name: 'receivable',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    view: 'receivable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/receivable/:invoiceId',
            name: 'commitment',
            callback: function (projectId, invoiceId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    invoiceId: parseInt(invoiceId),
                    view: 'receivable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/receivable/payments/:paymentId',
            name: 'commitment',
            callback: function (projectId, paymentId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    paymentId: parseInt(paymentId),
                    view: 'receivable'
                });
            }
        },
        {
            route: 'projects/:projectId/invoicing/billingperiods',
            name: 'invoicing',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "invoicing", {
                    view: 'billingperiods'
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.invoicing.routes);
